import React, { useEffect, useState } from "react";
import "./index.css";
import * as gtag from "../../gtag";

// Fallback content used when the API has no promo configured
const FALLBACK = {
  imageUrl: "/assets/sliman.jpg",
  bodyText: "Follow. Discover. Order. Support our new dream. 🥰👇",
  ctaUrl: "https://wa.me/21694088487",
};

function PromoModal({ isOpen, onClose, onOptOut, promo }) {
  const [secondsLeft, setSecondsLeft] = useState(5);

  useEffect(() => {
    if (!isOpen) return;
    const timerId = setTimeout(() => onClose(), 5000);
    return () => clearTimeout(timerId);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (!isOpen) return;
    setSecondsLeft(5);
    const intervalId = setInterval(() => {
      setSecondsLeft((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(intervalId);
  }, [isOpen]);

  if (!isOpen) return null;

  const imageUrl = promo?.imageUrl || FALLBACK.imageUrl;
  const bodyText = promo?.bodyText || FALLBACK.bodyText;
  const ctaUrl   = promo?.ctaUrl   || FALLBACK.ctaUrl;

  return (
    <div className="promo-modal__backdrop" role="dialog" aria-modal="true">
      <div className="promo-modal__content promo-modal__content--paper">
        <button className="promo-modal__close" onClick={onClose} aria-label="Close">×</button>

        <div className="paper-hands">
          <div className="hand hand--left">👋</div>
          <div className="hand hand--right">👋</div>
        </div>

        <div className="promo-paper" aria-live="polite">
          <div className="promo-paper__inner">
            <h2 className="promo-paper__title">
              🤭 !هو حتى حاتم بالحاج مايعرفش شنوا فيها
            </h2>
            <div className="promo-paper__image">
              <img src={imageUrl} alt="Pisu promo" className="sarcastic-image" />
            </div>
            <p className="promo-paper__body" dir="auto">{bodyText}</p>
            <div className="promo-modal__tags">
              <span className="promo-modal__tag">#Pisu</span>
              <span className="promo-modal__tag">#SupportSmallBusiness</span>
              <span className="promo-modal__tag">#ShopSmall</span>
            </div>
            <div className="promo-modal__actions">
              <button
                className="promo-modal__primary"
                onClick={() => {
                  window.open("https://www.instagram.com/pisu.tn/", "_blank", "noopener,noreferrer");
                  gtag.event({ action: "visit_instagram", category: "instagram", label: "Visit Instagram", value: 1 });
                }}
              >
                Visit Instagram
              </button>
              <button
                className="promo-modal__secondary"
                onClick={() => {
                  window.open(ctaUrl, "_blank", "noopener,noreferrer");
                  gtag.event({ action: "contact_us", category: "contact", label: "Contact Us", value: 1 });
                }}
              >
                Contact us
              </button>
            </div>
            <button className="promo-modal__optout" onClick={onOptOut}>
              Don't show this again
            </button>
            <div className="promo-modal__hint">
              This message closes automatically in {secondsLeft}s.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PromoModal;
